/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isObject, merge, omitBy, pick } from 'lodash';
import { gt } from 'semver';

// Components
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import FileDropper from 'shared/ui/components/form-components/pickers/FileDropper.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

const __vue_script__ = {
    name: 'PublicLoginI18nPage',

    components: { ExpandableContent, FileDropper, SearchBar },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            allKeys: [],
            authI18n: {},
            customTranslations: {},
            customT9sBit: {},
            defaultTranslations: {},
            enabled: false,
            i18nBit: {},
            languages: [],
            pkgI18nBit: {},
            pkgPubLoginBit: {},
            pubLoginBit: {},
            ready: false,
            searchTerm: '',
            LOGIN_NAMESPACES: ['login', 'registration', 'validations']
        };
    },

    created() {
        this.loadBits();
    },

    methods: {
        async loadBits() {
            const { remapMessages, flattenObject } = this.$utils.locales;

            try {
                this.pkgPubLoginBit = await this.$services.documents.getDocById(this.params.event._id, 'pkg-public-login-public-login-i18n-bit');
                this.pkgI18nBit = await this.$services.documents.getDocById(this.params.event._id, 'i18n-i18n-bit');
            } catch (error) {
                console.error('[PublicLoginI18nPage] Error loading package bits:', error);
            }

            try {
                const customT9nBit = await this.$services.documents.getDocById(this.params.event._id, 'bstg-i18n-bit');
                this.customT9sBit = flattenObject(remapMessages({}, pick(customT9nBit, this.LOGIN_NAMESPACES)));
            } catch (error) {
                console.warn('[PublicLoginI18nPage] It looks like there are no custom translations:', error);
            }

            try {
                const regConfig = await this.$services.pax.getRegistrationConfig(this.params.event._id);

                this.pubLoginBit = flattenObject(remapMessages({}, pick(this.pkgPubLoginBit, this.LOGIN_NAMESPACES)));
                this.i18nBit = flattenObject(remapMessages({}, pick(this.pkgI18nBit, this.LOGIN_NAMESPACES)));

                // This is what the BE collected from all sources (packages and event producers custom translations)
                const authI18n = remapMessages({}, pick(regConfig.i18n, this.LOGIN_NAMESPACES));
                this.authI18n = flattenObject(authI18n);
                this.languages = Object.keys(authI18n);

                this.enabled = true;
            } catch (error) {
                console.error('[PublicLoginI18nPage] Error loading auth translations:', error);
            } finally {
                this.ready = true;
            }
        },

        /**
         * @param {FileList} data
         */
        parseJsonFile(filelist) {
            if (!filelist?.length || !filelist?.[0]) {
                console.warn('[PublicLoginI18nPage] No file selected or file is invalid');
                return;
            }

            const lang = filelist[0].name.split('.').slice(-2, -1)[0];
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const json = JSON.parse(e.target.result);
                    const t9n = { [lang]: pick(json, this.LOGIN_NAMESPACES) };
                    this.defaultTranslations = this.$utils.locales.flattenObject(t9n);

                    const allKeys = new Set();
                    Object.keys(this.defaultTranslations).forEach(item => allKeys.add(item));
                    Object.keys(this.pubLoginBit).forEach(item => allKeys.add(item));
                    Object.keys(this.i18nBit).forEach(item => allKeys.add(item));
                    Object.keys(this.customT9sBit).forEach(item => allKeys.add(item));
                    Object.keys(this.authI18n).forEach(item => allKeys.add(item));

                    this.allKeys = Array.from(allKeys).sort();
                } catch (err) {
                    console.error('[PublicLoginI18nPage] Invalid JSON file', err);
                }
            };

            reader.onerror = () => {
                console.error('[PublicLoginI18nPage] Error reading file:', reader.error);
            };

            reader.readAsText(filelist[0]);
        },

        languageTranslations(lang, namespace) {
            if (this.searchTerm.length > 0) {
                const query = this.searchTerm.toLocaleLowerCase();
                return this.allKeys.filter(key => {
                    const value = (this.authI18n[key] || this.defaultTranslations[key] || '').toLocaleLowerCase();
                    const starting = key.startsWith(`${lang}.${namespace}`);
                    const contains = key.includes(query) || value.includes(query);

                    return starting && contains;
                });
            }

            return this.allKeys.filter(key => key.startsWith(`${lang}.${namespace}`));
        },

        getKey(key, lang) {
            return key.replace(`${lang}.`, '');
        },

        hasT9(key, translations) {
            return Boolean(get(translations || {}, key));
        },

        notInPackage(tKey) {
            return !this.hasT9(tKey, this.pubLoginBit) && !this.hasT9(tKey, this.i18nBit) && !this.hasT9(tKey, this.customT9sBit);
        },

        async exportToLoginPackage() {
            try {
                const packageInfo = await this.$services.market.getPackageDetails('public-login', this.params.event._id);
                this.exportToPackage('public-login', this.pkgPubLoginBit, ['login', 'registration'], packageInfo);
            } catch (error) {
                console.error('[PublicLoginI18nPage] Error fetching package details for public-login:', error);
                this.$notify({
                    group: 'flashes',
                    type: 'error',
                    text: this.$t('dev_tools.public_login_i18n.package_public_login_not_found', ['public-login']),
                    duration: 5000
                });
            }
        },

        async exportToI18nPackage() {
            try {
                const libs = await this.$services.market.getEventLibraries(this.params.event._id);
                const packageInfo = libs?.find(a => a.name === 'i18n');
                this.exportToPackage('i18n', this.pkgI18nBit, ['validations'], packageInfo);
            } catch (error) {
                console.error('[PublicLoginI18nPage] Error fetching package details for i18n:', error);
                this.$notify({
                    group: 'flashes',
                    type: 'error',
                    text: this.$t('dev_tools.public_login_i18n.package_i18n_not_found', ['i18n']),
                    duration: 5000
                });
            }
        },

        async exportToPackage(packageName, bit, namespaces, packageInfo) {
            console.info(packageInfo);

            let updateNeeded = false;
            if (packageInfo.is_critical) {
                updateNeeded = packageInfo.update !== packageInfo.patch;
            } else {
                updateNeeded = packageInfo.update && gt(packageInfo.update, packageInfo.installedVersion);
            }

            if (!updateNeeded) {
                this.buildExportFile(packageName, bit, namespaces);
            } else {
                console.warn(`[PublicLoginI18nPage] Package ${packageName} is not available for export.`);
                this.$notify({
                    group: 'flashes',
                    type: 'error',
                    text: this.$t('dev_tools.public_login_i18n.package_not_up_to_date', [packageName]),
                    duration: 15000
                });
            }
        },

        buildExportFile(packageName, bit, namespaces) {
            const translationsMap = {};
            this.allKeys.forEach(key => {
                if (this.notInPackage(key) && namespaces.some(ns => key.startsWith(`en.${ns}.`))) {
                    translationsMap[key] = this.authI18n[key] || this.defaultTranslations[key];
                }
            });

            const translationsToExport = {};
            for (const key of Object.keys(translationsMap)) {
                const parts = key.split('.');
                const [lang, ...rest] = parts;
                rest.push(lang);
                const newKey = rest.join('.');
                this.$utils.objects.setNoArray(translationsToExport, newKey, translationsMap[key]);
            }

            const fileContent = merge({}, omitBy(bit, v => !isObject(v)), translationsToExport);
            const jsonStr = JSON.stringify(this.$utils.objects.deepSortKeys(fileContent), null, 4);
            const blob = new Blob([jsonStr], { type: 'application/json' });

            this.$utils.browser.downloadBlob(blob, `${packageName}.json`);

            console.info('[PublicLoginI18nPage] Exporting translations to %s package:', packageName, fileContent);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        { staticClass: "public-login-i18n" },
        [
          _c("h1", [
            _vm._v(_vm._s(_vm.$t("dev_tools.public_login_i18n.title"))),
          ]),
          !_vm.enabled
            ? _c("div", { staticClass: "alert alert-warning" }, [
                _c("i", { staticClass: "ic-alert-triangle" }),
                _vm._v(
                  _vm._s(
                    _vm.$t("dev_tools.public_login_i18n.no_public_reg_found")
                  )
                ),
              ])
            : [
                !_vm.allKeys.length
                  ? _c("file-dropper", {
                      attrs: {
                        label: _vm.$t(
                          "dev_tools.public_login_i18n.select_webapp_auth_localization_file"
                        ),
                        hint: _vm.$t(
                          "dev_tools.public_login_i18n.select_webapp_auth_localization_file_hint"
                        ),
                        multiple: false,
                        "supported-mimes": ["application/json"],
                      },
                      on: { input: _vm.parseJsonFile },
                    })
                  : _c(
                      "div",
                      { staticClass: "languages" },
                      [
                        _c(
                          "div",
                          { staticClass: "controls" },
                          [
                            _c("div", { staticClass: "calls-to-action" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" },
                                  on: { click: _vm.exportToLoginPackage },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dev_tools.public_login_i18n.export_to_login_package"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" },
                                  on: { click: _vm.exportToI18nPackage },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dev_tools.public_login_i18n.export_to_i18n_package"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.allKeys = []
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dev_tools.public_login_i18n.reset"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _c("search-bar", {
                              attrs: { "show-no-result": false },
                              model: {
                                value: _vm.searchTerm,
                                callback: function ($$v) {
                                  _vm.searchTerm = $$v
                                },
                                expression: "searchTerm",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._l(_vm.languages, function (lang) {
                          return _c(
                            "expandable-content",
                            {
                              staticClass: "language",
                              attrs: {
                                "show-toggler": false,
                                "clickable-header": true,
                                slim: true,
                                "unlimited-height": true,
                                "content-class": "namespaces",
                                "is-open": true,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (ref) {
                                      var open = ref.open
                                      return [
                                        _c("h2", { class: { open: open } }, [
                                          _c("i", {
                                            staticClass: "ic-chevron-down",
                                          }),
                                          _vm._v(_vm._s(lang)),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._l(
                                _vm.LOGIN_NAMESPACES,
                                function (namespace) {
                                  return [
                                    _vm.languageTranslations(lang, namespace)
                                      .length
                                      ? _c(
                                          "expandable-content",
                                          {
                                            staticClass: "namespace",
                                            attrs: {
                                              "clickable-header": true,
                                              slim: true,
                                              "unlimited-height": true,
                                              "is-open": true,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "header",
                                                  fn: function (ref) {
                                                    var open = ref.open
                                                    return [
                                                      _c("h3", [
                                                        _vm._v(
                                                          _vm._s(namespace)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "table-wrapper" },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table-striped",
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass: "tkey",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dev_tools.public_login_i18n.headers.translation"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dev_tools.public_login_i18n.headers.translation_value"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "origin",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dev_tools.public_login_i18n.headers.origin"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                    ]),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.languageTranslations(
                                                          lang,
                                                          namespace
                                                        ),
                                                        function (tKey) {
                                                          return _c(
                                                            "tr",
                                                            {
                                                              class: {
                                                                custom:
                                                                  _vm.hasT9(
                                                                    tKey,
                                                                    _vm.customT9sBit
                                                                  ),
                                                                missing:
                                                                  _vm.notInPackage(
                                                                    tKey,
                                                                    lang
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "tkey",
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.getKey(
                                                                          tKey,
                                                                          lang,
                                                                          namespace
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm.notInPackage(
                                                                    tKey,
                                                                    lang
                                                                  )
                                                                    ? _c("i", {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "tooltip",
                                                                              rawName:
                                                                                "v-tooltip",
                                                                              value:
                                                                                _vm.$t(
                                                                                  "dev_tools.public_login_i18n.missing_translation_key"
                                                                                ),
                                                                              expression:
                                                                                "$t('dev_tools.public_login_i18n.missing_translation_key')",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "ic-alert-triangle",
                                                                      })
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "value",
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .authI18n[
                                                                          tKey
                                                                        ] ||
                                                                          _vm
                                                                            .defaultTranslations[
                                                                            tKey
                                                                          ]
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "origin",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "origins",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value:
                                                                                  _vm.$t(
                                                                                    "dev_tools.public_login_i18n.origins.default"
                                                                                  ),
                                                                                expression:
                                                                                  "$t('dev_tools.public_login_i18n.origins.default')",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "badge default",
                                                                          class:
                                                                            {
                                                                              invisible:
                                                                                !_vm.notInPackage(
                                                                                  tKey,
                                                                                  lang
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "D"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value:
                                                                                  _vm.$t(
                                                                                    "dev_tools.public_login_i18n.origins.pub_login"
                                                                                  ),
                                                                                expression:
                                                                                  "$t('dev_tools.public_login_i18n.origins.pub_login')",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "badge custom",
                                                                          class:
                                                                            {
                                                                              invisible:
                                                                                !_vm.hasT9(
                                                                                  tKey,
                                                                                  _vm.pubLoginBit
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "L"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value:
                                                                                  _vm.$t(
                                                                                    "dev_tools.public_login_i18n.origins.i18n"
                                                                                  ),
                                                                                expression:
                                                                                  "$t('dev_tools.public_login_i18n.origins.i18n')",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "badge pub-login",
                                                                          class:
                                                                            {
                                                                              invisible:
                                                                                !_vm.hasT9(
                                                                                  tKey,
                                                                                  _vm.i18nBit
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "I"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value:
                                                                                  _vm.$t(
                                                                                    "dev_tools.public_login_i18n.origins.custom"
                                                                                  ),
                                                                                expression:
                                                                                  "$t('dev_tools.public_login_i18n.origins.custom')",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "badge i18n",
                                                                          class:
                                                                            {
                                                                              invisible:
                                                                                !_vm.hasT9(
                                                                                  tKey,
                                                                                  _vm.customT9sBit
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "C"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    ),
              ],
        ],
        2
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/dev-tools/PublicLoginI18n.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__